import React, { useState } from 'react';
import { useOfflineStatus, retryItem, dismissItem, syncQueue } from '../lib/offline';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');

const IssueRow = ({ item }) => (
    <li className="border-b border-zinc-800 py-3" data-testid={`offline-issue-${item.id}`}>
        <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
                <p className="text-sm text-white">{item.label}</p>
                <p className="text-xs text-zinc-400">Saisie hors ligne le {fmt(item.queued_at)}</p>
                <p className={`text-xs mt-1 ${item.status === 'conflict' ? 'text-amber-400' : 'text-red-400'}`}>
                    {item.status === 'conflict' ? 'Conflit — ' : 'Refusée — '}{item.error}
                </p>
            </div>
            <div className="flex gap-2 shrink-0">
                {item.status === 'failed' && (
                    <Button size="sm" variant="outline" onClick={() => retryItem(item.id)} data-testid={`offline-retry-${item.id}`}>Réessayer</Button>
                )}
                <Button size="sm" variant="ghost" onClick={() => dismissItem(item.id)} data-testid={`offline-dismiss-${item.id}`}>Retirer</Button>
            </div>
        </div>
    </li>
);

const OfflineBanner = () => {
    const { online, pending, syncing, issues, lastDataAt } = useOfflineStatus();
    const [open, setOpen] = useState(false);
    if (online && !pending && !syncing && !issues.length) return null;

    let tone = 'offline-banner-info';
    let text = '';
    if (!online) {
        tone = 'offline-banner-warning';
        text = `Mode hors ligne — consultation des dernières données reçues (${fmt(lastDataAt)}). Les saisies sont conservées sur cet appareil.`;
    } else if (syncing || pending) {
        text = `Synchronisation en cours — ${pending} saisie(s) hors ligne en attente d'envoi.`;
    }

    return (
        <div className={`offline-banner ${tone}`} data-testid="offline-banner">
            <span data-testid="offline-banner-text">{text || 'Synchronisation terminée.'}</span>
            {!online && pending > 0 && <span className="offline-banner-count" data-testid="offline-pending-count">{pending} en attente</span>}
            {online && pending > 0 && !syncing && (
                <button type="button" className="offline-banner-link" onClick={syncQueue} data-testid="offline-sync-now-btn">Envoyer maintenant</button>
            )}
            {issues.length > 0 && (
                <button type="button" className="offline-banner-link" onClick={() => setOpen(true)} data-testid="offline-issues-btn">
                    {issues.length} saisie(s) à vérifier
                </button>
            )}
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="max-w-lg" data-testid="offline-issues-dialog">
                    <DialogHeader><DialogTitle>Saisies hors ligne à vérifier</DialogTitle></DialogHeader>
                    <p className="text-xs text-zinc-400">En cas de conflit, la modification la plus récente est conservée et l'événement est tracé dans la main courante.</p>
                    <ul>{issues.map((item) => <IssueRow key={item.id} item={item} />)}</ul>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default OfflineBanner;
